import { tokens } from "../theme";

export const mockDataTeam = [
    {
        id: 1,
        name: "Luke Skywalker",
        email: "luke@gmail.com",
        age: 35,
        phone: "(665)121-5454",
        access: "admin",
    },
    {
        id: 2,
        name: "Han Solo",
        email: "hansolo@gmail.com",
        age: 42,
        phone: "(421)314-2288",
        access: "manager",
    },
    {
        id: 3,
        name: "Obi-Wan Kenobi",
        email: "obi1@gmail.com",
        age: 45,
        phone: "(422)982-6739",
        access: "user",
    },
    {
        id: 4,
        name: "Yoda",
        email: "yoda@gmail.com",
        age: 16,
        phone: "(921)425-6742",
        access: "admin",
    },
    {
        id: 5,
        name: "Princess Leia",
        email: "leia@gmail.com",
        age: 31,
        phone: "(421)445-1189",
        access: "user",
    },
    {
        id: 6,
        name: "R2-D2",
        email: "r2@gmail.com",
        age: 150,
        phone: "(232)545-6483",
        access: "manager",
    },
    {
        id: 7,
        name: "Chewbacca",
        email: "chewie@gmail.com",
        age: 44,
        phone: "(543)124-0123",
        access: "user",
    },
    {
        id: 8,
        name: "C-3PO",
        email: "rossinifrances@gmail.com",
        age: 36,
        phone: "(222)444-5555",
        access: "user",
    },
    {
        id: 9,
        name: "Boba Fett",
        email: "harveyroxie@gmail.com",
        age: 65,
        phone: "(444)555-6239",
        access: "admin",
    },
];

export const mockDataContacts = [
    {
        id: 1,
        name: "Luke Skywalker",
        email: "luke@gmail.com",
        age: 35,
        phone: "(665)121-5454",
        address: "0912 Won Street, Alabama, SY 10001",
        city: "New York",
        zipCode: "10001",
        registrarId: 123512,
    },
    {
        id: 2,
        name: "Han Solo",
        email: "hansolo@gmail.com",
        age: 42,
        phone: "(421)314-2288",
        address: "1234 Main Street, New York, NY 10001",
        city: "New York",
        zipCode: "13151",
        registrarId: 123512,
    },
    {
        id: 3,
        name: "Obi-Wan Kenobi",
        email: "obi1@gmail.com",
        age: 45,
        phone: "(422)982-6739",
        address: "3333 Want Blvd, Estanza, NAY 42125",
        city: "New York",
        zipCode: "87281",
        registrarId: 4132513,
    },
    {
        id: 4,
        name: "Yoda",
        email: "yoda@gmail.com",
        age: 16,
        phone: "(921)425-6742",
        address: "1514 Main Street, New York, NY 22298",
        city: "New York",
        zipCode: "15551",
        registrarId: 123512,
    },
    {
        id: 5,
        name: "Princess Leia",
        email: "leia@gmail.com",
        age: 31,
        phone: "(421)445-1189",
        address: "11122 Welping Ave, Tenting, CD 21321",
        city: "Tenting",
        zipCode: "14215",
        registrarId: 123512,
    },
    {
        id: 6,
        name: "R2-D2",
        email: "r2@gmail.com",
        age: 150,
        phone: "(232)545-6483",
        address: "1234 Canvile Street, Esvazark, NY 10001",
        city: "Esvazark",
        zipCode: "10001",
        registrarId: 123512,
    },
    {
        id: 7,
        name: "Chewbacca",
        email: "chewie@gmail.com",
        age: 44,
        phone: "(543)124-0123",
        address: "22215 Super Street, Everting, ZO 515234",
        city: "Evertin",
        zipCode: "51523",
        registrarId: 123512,
    },
    {
        id: 8,
        name: "C-3PO",
        email: "rossinifrances@gmail.com",
        age: 36,
        phone: "(222)444-5555",
        address: "4123 Ever Blvd, Wentington, AD 142213",
        city: "Esteras",
        zipCode: "44215",
        registrarId: 512315,
    },
    {
        id: 9,
        name: "Boba Fett",
        email: "harveyroxie@gmail.com",
        age: 65,
        phone: "(444)555-6239",
        address: "51234 Avery Street, Cantory, ND 212412",
        city: "Colunza",
        zipCode: "111234",
        registrarId: 928397,
    },
    {
        id: 10,
        name: "Grogu",
        email: "enteriredack@gmail.com",
        age: 42,
        phone: "(222)444-5555",
        address: "4123 Easer Blvd, Wentington, AD 142213",
        city: "Esteras",
        zipCode: "44215",
        registrarId: 533215,
    },
    {
        id: 11,
        name: "Ahsoka Tano",
        email: "stevegoodmane@gmail.com",
        age: 11,
        phone: "(444)555-6239",
        address: "51234 Fiveton Street, CunFory, ND 212412",
        city: "Colunza",
        zipCode: "1234",
        registrarId: 92197,
    },
];

export const mockDataInvoices = [
    {
        id: 1,
        name: "Luke Skywalker",
        email: "luke@gmail.com",
        cost: "21.24",
        phone: "(665)121-5454",
        date: "03/12/2022",
    },
    {
        id: 2,
        name: "Han Solo",
        email: "hansolo@gmail.com",
        cost: "1.24",
        phone: "(421)314-2288",
        date: "06/15/2021",
    },
    {
        id: 3,
        name: "Obi-Wan Kenobi",
        email: "obi1@gmail.com",
        cost: "11.24",
        phone: "(422)982-6739",
        date: "05/02/2022",
    },
    {
        id: 4,
        name: "Yoda",
        email: "yoda@gmail.com",
        cost: "80.55",
        phone: "(921)425-6742",
        date: "03/21/2022",
    },
    {
        id: 5,
        name: "Princess Leia",
        email: "leia@gmail.com",
        cost: "1.24",
        phone: "(421)445-1189",
        date: "01/12/2021",
    },
    {
        id: 6,
        name: "R2-D2",
        email: "r2@gmail.com",
        cost: "63.12",
        phone: "(232)545-6483",
        date: "11/02/2022",
    },
    {
        id: 7,
        name: "Chewbacca",
        email: "chewie@gmail.com",
        cost: "52.42",
        phone: "(543)124-0123",
        date: "02/11/2022",
    },
    {
        id: 8,
        name: "C-3PO",
        email: "rossinifrances@gmail.com",
        cost: "21.24",
        phone: "(222)444-5555",
        date: "05/02/2021",
    },
];

export const mockTransactions = [
    {
        txId: "01e4dsa",
        user: "johndoe",
        date: "2021-09-01",
        cost: "43.95",
    },
    {
        txId: "0315dsaa",
        user: "jackdower",
        date: "2022-04-01",
        cost: "133.45",
    },
    {
        txId: "01e4dsa",
        user: "aberdohnny",
        date: "2021-09-01",
        cost: "43.95",
    },
    {
        txId: "51034szv",
        user: "goodmanave",
        date: "2022-11-05",
        cost: "200.95",
    },
    {
        txId: "0a123sb",
        user: "stevebower",
        date: "2022-11-02",
        cost: "13.55",
    },
    {
        txId: "01e4dsa",
        user: "aberdohnny",
        date: "2021-09-01",
        cost: "43.95",
    },
    {
        txId: "120s51a",
        user: "wootzifer",
        date: "2019-04-15",
        cost: "24.20",
    },
    {
        txId: "0315dsaa",
        user: "jackdower",
        date: "2022-04-01",
        cost: "133.45",
    },
];

export const mockBarData = [
    {
        country: "AD",
        "TIE Fighter": 137,
        "TIE FighterColor": "hsl(229, 70%, 50%)",
        Infiltrator: 96,
        InfiltratorColor: "hsl(296, 70%, 50%)",
        Destroyer: 72,
        DestroyerColor: "hsl(97, 70%, 50%)",
        Starfighter: 140,
        StarfighterColor: "hsl(340, 70%, 50%)",
    },
    {
        country: "AE",
        "TIE Fighter": 55,
        "TIE FighterColor": "hsl(307, 70%, 50%)",
        Infiltrator: 28,
        InfiltratorColor: "hsl(111, 70%, 50%)",
        Destroyer: 58,
        DestroyerColor: "hsl(273, 70%, 50%)",
        Starfighter: 29,
        StarfighterColor: "hsl(275, 70%, 50%)",
    },
    {
        country: "AF",
        "TIE Fighter": 109,
        "TIE FighterColor": "hsl(72, 70%, 50%)",
        Infiltrator: 23,
        InfiltratorColor: "hsl(96, 70%, 50%)",
        Destroyer: 34,
        DestroyerColor: "hsl(106, 70%, 50%)",
        Starfighter: 152,
        StarfighterColor: "hsl(256, 70%, 50%)",
    },
    {
        country: "AG",
        "TIE Fighter": 133,
        "TIE FighterColor": "hsl(257, 70%, 50%)",
        Infiltrator: 52,
        InfiltratorColor: "hsl(326, 70%, 50%)",
        Destroyer: 43,
        DestroyerColor: "hsl(110, 70%, 50%)",
        Starfighter: 83,
        StarfighterColor: "hsl(9, 70%, 50%)",
    },
    {
        country: "AI",
        "TIE Fighter": 81,
        "TIE FighterColor": "hsl(190, 70%, 50%)",
        Infiltrator: 80,
        InfiltratorColor: "hsl(325, 70%, 50%)",
        Destroyer: 112,
        DestroyerColor: "hsl(54, 70%, 50%)",
        Starfighter: 35,
        StarfighterColor: "hsl(285, 70%, 50%)",
    },
    {
        country: "AL",
        "TIE Fighter": 66,
        "TIE FighterColor": "hsl(208, 70%, 50%)",
        Infiltrator: 111,
        InfiltratorColor: "hsl(334, 70%, 50%)",
        Destroyer: 167,
        DestroyerColor: "hsl(182, 70%, 50%)",
        Starfighter: 18,
        StarfighterColor: "hsl(76, 70%, 50%)",
    },
    {
        country: "AM",
        "TIE Fighter": 80,
        "TIE FighterColor": "hsl(87, 70%, 50%)",
        Infiltrator: 47,
        InfiltratorColor: "hsl(141, 70%, 50%)",
        Destroyer: 158,
        DestroyerColor: "hsl(224, 70%, 50%)",
        Starfighter: 49,
        StarfighterColor: "hsl(274, 70%, 50%)",
    },
];

export const mockPieData = [
    {
        id: "needlebeamer",
        label: "needlebeamer",
        value: 239,
        color: "hsl(104, 70%, 50%)",
    },
    {
        id: "parang",
        label: "parang",
        value: 170,
        color: "hsl(162, 70%, 50%)",
    },
    {
        id: "chaosphere",
        label: "chaosphere",
        value: 322,
        color: "hsl(291, 70%, 50%)",
    },
    {
        id: "diiro",
        label: "diiro",
        value: 503,
        color: "hsl(229, 70%, 50%)",
    },
    {
        id: "flashstick",
        label: "flashstick",
        value: 584,
        color: "hsl(344, 70%, 50%)",
    },
];

export const mockLineData = [
    {
        id: "Rebelion",
        color: tokens("dark").greenAccent[500],
        data: [
            {
                x: "Corellia",
                y: 101,
            },
            {
                x: "Naboo",
                y: 75,
            },
            {
                x: "Rori",
                y: 36,
            },
            {
                x: "Dathomir",
                y: 216,
            },
            {
                x: "Talus",
                y: 35,
            },
            {
                x: "Tatooine",
                y: 236,
            },
            {
                x: "Yavin 4",
                y: 88,
            },
            {
                x: "Kashyyyk",
                y: 232,
            },
            {
                x: "Lok",
                y: 281,
            },
            {
                x: "Hoth",
                y: 1,
            },
            {
                x: "Mustafar",
                y: 35,
            },
            {
                x: "others",
                y: 14,
            },
        ],
    },
    {
        id: "neutral",
        color: tokens("dark").blueAccent[300],
        data: [
            {
                x: "Corellia",
                y: 212,
            },
            {
                x: "Naboo",
                y: 190,
            },
            {
                x: "Rori",
                y: 270,
            },
            {
                x: "Dathomir",
                y: 9,
            },
            {
                x: "Talus",
                y: 75,
            },
            {
                x: "Tatooine",
                y: 175,
            },
            {
                x: "Yavin 4",
                y: 33,
            },
            {
                x: "Kashyyyk",
                y: 189,
            },
            {
                x: "Lok",
                y: 97,
            },
            {
                x: "Hoth",
                y: 87,
            },
            {
                x: "Mustafar",
                y: 299,
            },
            {
                x: "others",
                y: 251,
            },
        ],
    },
    {
        id: "Empire",
        color: tokens("dark").redAccent[200],
        data: [
            {
                x: "Corellia",
                y: 191,
            },
            {
                x: "Naboo",
                y: 136,
            },
            {
                x: "Rori",
                y: 91,
            },
            {
                x: "Dathomir",
                y: 190,
            },
            {
                x: "Talus",
                y: 211,
            },
            {
                x: "Tatooine",
                y: 152,
            },
            {
                x: "Yavin 4",
                y: 189,
            },
            {
                x: "Kashyyyk",
                y: 152,
            },
            {
                x: "Lok",
                y: 8,
            },
            {
                x: "Hoth",
                y: 197,
            },
            {
                x: "Mustafar",
                y: 107,
            },
            {
                x: "others",
                y: 170,
            },
        ],
    },
];
